/* Terra product page – lower sections: material switching, live mockup scenes, recently viewed. */
(function () {
  if(window.terraProductLowerLoaded) return; window.terraProductLowerLoaded=true;
  function groupOf(material) {
    var m = (material || '').toLowerCase();
    if (m.indexOf('frame') > -1) return 'framed';
    if (m.indexOf('poster') > -1) return 'poster';
    return 'canvas';
  }
  function labelOf(group) {
    return { framed: 'Framed Canvas', canvas: 'Canvas Art', poster: 'Poster Print' }[group] || '';
  }
  function currentMaterial() {
    var el = document.querySelector('input[data-option-name="Material"]:checked, input[data-option-name="material"]:checked');
    if (el) return el.value;
    var sel = document.querySelector('select[name*="Material"]');
    if (sel) return sel.value;
    var root = document.querySelector('[data-terra-initial-material]');
    return root ? root.getAttribute('data-terra-initial-material') : '';
  }
  function applyGroup() {
    var mat = currentMaterial();
    document.documentElement.classList.toggle('terra-is-single', !!mat && !/3 piece|triptych|set of 3/i.test(mat));
    var g = groupOf(mat);
    document.querySelectorAll('[data-terra-group]').forEach(function (el) {
      var groups = el.getAttribute('data-terra-group').split(' ');
      el.hidden = !(groups.indexOf(g) > -1 || groups.indexOf('all') > -1);
    });
    document.querySelectorAll('[data-terra-material-label]').forEach(function (el) { el.textContent = labelOf(g); });
    uniqueScenes(g, !!mat && !/3 piece|triptych|set of 3/i.test(mat));
    renderScenes();
  }

/* Same-artwork photo allocation. One URL per visible Features + Inspiration view. */
function terraPlanScenes(media, group, single, slots) {
  var seen = {}, pool = media.filter(function(m) {
    var name = m.src.split('?')[0].split('/').pop().toLowerCase();
    if (seen[name] || /size-options|size-guide|how.big|crystal|no.pixelation|artwork-source/.test(name)) return false;
    seen[name] = true;
    m.key = name;
    m.groups = (m.material || 'all').trim().split(/\s+/);
    m.group = /framed/.test(m.material) ? 'framed' : (/poster/.test(m.material) ? 'poster' : (/canvas/.test(m.material) ? 'canvas' : 'all'));
    var hasSingle = m.groups.some(function(k){return /^(canvas|framed|poster)$/.test(k);});
    var hasThree = m.groups.some(function(k){return /3$/.test(k);});
    m.panels = hasThree && !hasSingle ? 3 : (hasSingle && !hasThree ? 1 : 0);
    m.role = /corner/.test(name) ? 'corner' : (/hold|held|hands/.test(name) ? 'hold' : (/wall3/.test(name) ? 'wall3' : (/room-tri|room-single|living-room|bedroom|interior/.test(name) ? 'room' : (/detail|close.up/.test(name) ? 'detail' : (/front/.test(name) ? 'front' : 'main')))));
    return true;
  });
  var used = {};
  return slots.map(function(slot) {
    var candidates = pool.filter(function(m){return !used[m.key];});
    candidates.sort(function(a,b){return score(b,slot)-score(a,slot) || a.order-b.order;});
    var pick = candidates[0];
    if(pick) used[pick.key] = true;
    return pick || null;
  });
  function score(m, slot) {
    var s = m.group === group ? 45 : (m.group === 'all' ? 20 : 0);
    s += m.panels === (single ? 1 : 3) ? 30 : (m.panels === 0 ? 15 : 0);
    if(slot === 'room') s += m.role === 'room' ? 160 : (m.role === 'wall3' ? 90 : (m.role === 'hold' ? 30 : 0));
    else if(m.role === slot) s += 180;
    else if(slot === 'wall3' && m.role === 'room') s += 130;
    else if(slot === 'corner' && m.role === 'detail') s += 140;
    else if(slot === 'hold' && m.role === 'detail') s += 100;
    else if(m.role === 'room') s += 30;
    if(m.role === 'front') s -= 5;
    return s;
  }
}

  function uniqueScenes(group, single) {
    var data = document.querySelector('[data-terra-scene-catalog]');
    if(!data) return;
    var media; try { media=JSON.parse(data.textContent); } catch(e) { return; }
    var cards = [], slots = [];
    document.querySelectorAll('.terra-features__grid:not([hidden]) .terra-feature').forEach(function(card){
      var key=card.getAttribute('data-terra-scene-key');
      if(key==='pack') return;
      cards.push(card); slots.push(key==='corner'||key==='hold' ? key : 'wall3');
    });
    document.querySelectorAll('.terra-inspo__item:not([hidden])').forEach(function(card){cards.push(card); slots.push('room');});
    var picks=terraPlanScenes(media,group,single,slots);
    cards.forEach(function(card,index){
      var photo=picks[index], scene=card.querySelector('.terra-scene'); if(!photo||!scene) return;
      var signature=photo.key+'|'+group+'|'+single;
      if(scene.getAttribute('data-terra-unique-photo')===signature) return;
      scene.className='terra-scene terra-scene--photo'; scene.removeAttribute('data-quad'); scene.removeAttribute('data-panels');
      scene.setAttribute('data-terra-unique-photo',signature); scene.setAttribute('data-terra-photo-material',photo.group);
      var img=document.createElement('img'); img.className='terra-scene__photo'; img.loading='lazy'; img.src=photo.src;
      img.alt=photo.alt || 'Artwork preview'; img.width=img.height=1400;
      scene.replaceChildren(img);
      var actual=photo.group==='all' ? group : photo.group;
      var format=photo.panels===3 ? '3 piece set' : (photo.panels===1 ? 'single artwork' : 'artwork detail');
      var caption=labelOf(actual)+' — '+format;
      if(card.classList.contains('terra-inspo__item')) {
        var cap=card.querySelector('figcaption'); if(cap) cap.textContent=caption;
      } else {
        var title=card.querySelector('.terra-feature__title'), text=card.querySelector('.terra-feature__text');
        if(!card._terraOriginal) card._terraOriginal={title:title ? title.textContent : '',text:text ? text.innerHTML : ''};
        if(actual!==group) {
          if(title) title.textContent=labelOf(actual)+' Preview';
          if(text) text.textContent='The same artwork shown as '+labelOf(actual).toLowerCase()+'. Choose your preferred material above.';
        } else {
          if(title) title.textContent=card._terraOriginal.title;
          if(text) text.innerHTML=card._terraOriginal.text;
        }
      }
    });
  }

  /* Homography: unit square -> quad (points in px). Returns CSS matrix3d. */
  function quadMatrix(w, h, q) {
    var x0 = q[0], y0 = q[1], x1 = q[2], y1 = q[3], x2 = q[4], y2 = q[5], x3 = q[6], y3 = q[7];
    var dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3;
    var dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
    var den = dx1 * dy2 - dx2 * dy1;
    var g = (dx3 * dy2 - dx2 * dy3) / den, hh = (dx1 * dy3 - dx3 * dy1) / den;
    var a = x1 - x0 + g * x1, b = x3 - x0 + hh * x3, c = x0;
    var d = y1 - y0 + g * y1, e = y3 - y0 + hh * y3, f = y0;
    a /= w; d /= w; g /= w; b /= h; e /= h; hh /= h;
    return 'matrix3d(' + [a, d, 0, g, b, e, 0, hh, 0, 0, 1, 0, c, f, 0, 1].join(',') + ')';
  }
  function renderScenes() {
    document.querySelectorAll('.terra-scene[data-quad]').forEach(function (scene) {
      if (scene.closest('[hidden]')) return;
      var art = scene.querySelector('.terra-scene__art');
      var mask = scene.querySelector('.terra-scene__mask');
      if (!art || !mask || !mask.naturalWidth) return;
      var panels = parseInt(scene.getAttribute('data-panels') || '1', 10);
      var quads = scene.getAttribute('data-quad').split('|');
      var W = scene.clientWidth, H = scene.clientHeight;
      var sx = W / mask.naturalWidth, sy = H / mask.naturalHeight;
      var holders = scene.querySelectorAll('.terra-scene__art');
      quads.forEach(function (qs, i) {
        var el = holders[i]; if (!el) return;
        var q = qs.split(',').map(Number).map(function (v, k) { return k % 2 ? v * sy : v * sx; });
        var aw = 1000, ah = Math.round(1000 / (2 / panels));
        el.style.width = aw + 'px'; el.style.height = ah + 'px';
        el.style.backgroundSize = (panels * 100) + '% 100%';
        el.style.backgroundPosition = (panels > 1 ? (i * 100 / (panels - 1)) : 0) + '% 0';
        el.style.transform = quadMatrix(aw, ah, q);
      });
    });
  }

  function recentlyViewed() {
    var box = document.querySelector('[data-terra-recent]');
    var handle = box ? box.getAttribute('data-current') : null;
    var key = 'terra_recent_v1', list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    if (handle) {
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
      try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
    }
    if (!box) return;
    var others = list.filter(function (h) { return h !== handle; }).slice(0, 6);
    if (!others.length) return;
    var grid = box.querySelector('.terra-recent__grid');
    Promise.all(others.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) return;
      grid.innerHTML = items.map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
        var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
        return '<a class="terra-card" href="' + p.url + '"><span class="terra-card__media">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') +
          '</span><span class="terra-card__title">' + p.title + '</span><span class="terra-card__price">From ' + price + '</span></a>';
      }).join('');
      box.hidden = false;
    });
  }


  var CH_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>', CH_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  function scrollers() {
    document.querySelectorAll('.terra-track, .terra-cards, .terra-features__grid, .terra-recent__grid').forEach(function (track) {
      if (track.getAttribute('data-terra-arrows')) return;
      track.setAttribute('data-terra-arrows', '1');
      var wrap = document.createElement('div'); wrap.className = 'terra-scroller';
      track.parentNode.insertBefore(wrap, track); wrap.appendChild(track);
      var pv = document.createElement('button'), nx = document.createElement('button');
      pv.type = nx.type = 'button'; pv.className = 'terra-round-arrow terra-round-arrow--prev'; nx.className = 'terra-round-arrow terra-round-arrow--next';
      pv.setAttribute('aria-label', 'Previous'); nx.setAttribute('aria-label', 'Next'); pv.innerHTML = CH_L; nx.innerHTML = CH_R;
      wrap.appendChild(pv); wrap.appendChild(nx);
      function upd() {
        var img = track.querySelector('img, .terra-scene, .terra-card__media');
        if (img && img.offsetHeight) wrap.style.setProperty('--terra-arrow-top', (img.offsetTop - track.offsetTop + img.offsetHeight / 2) + 'px');
        var over = !track.hidden && track.offsetParent !== null && track.scrollWidth > track.clientWidth + 4;
        pv.disabled = !over || track.scrollLeft <= 4; nx.disabled = !over || track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      function go(d) { track.scrollBy({ left: d * Math.max(track.clientWidth * 0.8, 200), behavior: 'smooth' }); setTimeout(upd, 450); }
      pv.addEventListener('click', function () { go(-1); }); nx.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(upd, 60); }, { passive: true });
      track.addEventListener('scrollend', upd);
      window.addEventListener('resize', upd); window.addEventListener('load', upd);
      document.addEventListener('change', function () { setTimeout(upd, 120); setTimeout(upd, 700); });
      track._terraUpd = upd; setTimeout(upd, 60);
    });
    document.querySelectorAll('[data-terra-arrows]').forEach(function (t) { if (t._terraUpd) t._terraUpd(); });
  }
  function alternate() {
    var main = document.querySelector('main'); if (!main) return;
    var secs = Array.prototype.slice.call(main.children).filter(function (s) { return s.classList && s.classList.contains('shopify-section'); });
    var start = secs.findIndex(function (s) { return /main-product|__main$/.test(s.id) || s.querySelector('product-info'); });
    var list = secs.slice(start + 1).filter(function (s) { return s.offsetHeight > 90; });
    var sizeIdx = list.findIndex(function (s) { return s.querySelector('.terra-sizes'); });
    var offset = sizeIdx > -1 ? sizeIdx % 2 : 0;
    list.forEach(function (s, i) { var tint = (i % 2) === offset; s.classList.toggle('terra-alt-tint', tint); s.classList.toggle('terra-alt-white', !tint); });
  }

  function init() {
    applyGroup();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[data-option-name], select')) { setTimeout(applyGroup, 30); setTimeout(applyGroup, 500); }
    });
    document.querySelectorAll('.terra-scene__mask').forEach(function (m) { m.addEventListener('load', renderScenes); });
    window.addEventListener('resize', renderScenes);
    recentlyViewed();
    scrollers();
    alternate();
    window.addEventListener('load', function () { scrollers(); alternate(); });
    setTimeout(alternate, 1500);
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(function () { scrollers(); alternate(); }, 200); });
      var mn = document.querySelector('main'); if (mn) mo.observe(mn, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
